var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cnav aria-label=\"Page navigation\"\u003E \u003Cul uib-pagination total-items=\"$pagination.total\" items-per-page=\"$pagination.limit\" force-ellipses=\"true\" max-size=\"5\" boundary-link-numbers=\"true\" previous-text=\"&lt;\" next-text=\"&gt;\" ng-model=\"$pagination.page\" ng-change=\"move($pagination.page)\"\u003E\u003C\u002Ful\u003E\u003C\u002Fnav\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/common/resource/paginator/index.pug
// module id = 224
// module chunks = 0